export const FS_CHAT_SERVICE = '/service/fs-chat/api'
export const MEMORIES_SERVICE = '/service/memories'
export const ORCHESTRATION_SERVICE = '/service/orchestration'
export const PATRON_BEHAVIOR_SERVICE = '/service/home/pb'
export const ROOTSTECH_SERVICE = '/service/rootstech'
export const STANDARDS_SERVICE = '/service/standards'
export const USER_SERVICE = '/service/user'
